module.exports = __webpack_public_path__ + "static/img/bg2-hover.97524772.png";